import utilRouter from "@/libs/util.router.js";
const config = {
  navMenuConfig: {
    title: "广东轻工职业技术学院人民数字马院",
    menuBackgroundColor: "#ffaf2a",
    menuTextColor: "#fff",
    menuActiveTextColor: "#fff",
  },
  relationId: "337",
  menuList: [
    {
      title: "首页",
      type: 1,
      content: "/tjxd/portal",
      subMenuList: [],
      isActive: utilRouter.isPathActive,
    },
    {
      title: "通知新闻",
      type: 1,
      content: `/tjxd/news/2307?type=1`,
      subMenuList: [],
      isActive: isNewsActive(2307),
    },
    {
      title: "政策文件",
      type: 1,
      content: `/tjxd/news/2322?type=2`,
      subMenuList: [],
      isActive: isNewsActive(2322),
    },
    {
      title: "思政课程",
      type: 1,
      content: `/tjxd/ideologicalCourses`,
      subMenuList: [],
      isActive: utilRouter.isPathActive,
    },
    {
      title: "热点课程",
      type: 1,
      content: `/tjxd/courses`,
      isActive: isCourseActive(),
      subMenuList: [],
    },
    {
      title: "资源库",
      type: 1,
      content: `/tjxd/resources`,
      isActive: utilRouter.noop,
      subMenuList: [
        {
          title: "备课资源库",
          type: 2,
          content: "http://rm.ulearning.cn/#/portal/23",
          isActive: utilRouter.isPathActive,
        },
        {
          title: "人民数据权威党政、时政信息平台",
          type: 2,
          content: "http://data.people.com.cn/publish/_s1/0819.html",
          isActive: utilRouter.isPathActive,
        },
        {
          title: "习近平系列重要讲话数据库",
          type: 2,
          content:
            "https://marx.ulearning.cn/digitalweb/prepareResource.do?page=2",
          isActive: utilRouter.isPathActive,
        },
      ],
    },
    {
      title: "联盟名师",
      type: 1,
      content: "/tjxd/teachers",
      isActive:isTeachersActive(),
      subMenuList: [],
      mate:{
        site:'tjxd'
      }
    },
    {
      title: "微课程",
      type: 1,
      content: `/tjxd/brands/337`,
      isActive:isBrandsActive(337),
      subMenuList: [],
    },
    {
      title: "评审活动",
      type: 2,
      content: "https://hjy-dasai.ulearning.cn/",
      isActive: utilRouter.isPathActive,
      subMenuList: [],
    },
    {
      title: "数字红馆",
      type: 1,
      content: "/tjxd/practiceBase",
      isActive: utilRouter.isPathActive,
      subMenuList: [],
    },
    {
      title: "课程群",
      type: 1,
      content: "/tjxd/curriculumGroup/337",
      isActive: utilRouter.isPathActive,
      subMenuList: [],
    },
  ],
  menus: [{
    id: 1,
    title: "通知新闻",
    type: 1,
    menuId: 2113
  }, {
    id: 2,
    title: "政策文件",
    type: 2,
    menuId: 2114
  }, {
    id: 3,
    title: "数字红馆",
    type: 2,
    menuId: 1725
  }],
  breadConfig: {
    Icon: "",
    firstBreTitle: "首页",
    separator: ">",
    breadTitle: "文章详情",
  },
};
function isNewsActive(id) {
  var rules = [
    {
      path: "/tjxd/news/:menuId",
      params: {
        menuId:id,
      },
    },
    {
      path: "/tjxd/newsContent/:menuId/:id",
      params: {
        menuId:id,
      }
    }
  ];
  return function(route) {
    return utilRouter.isMatch(route, rules);
  };
}
function isCourseActive() {
  var rules = [
    {
      path: "/tjxd/courseContent/:id",
    },
    {
      path: "/tjxd/courses",
    },
  ];

  return function(route) {
    return utilRouter.isMatch(route, rules);
  };
}
function isTeachersActive() {
  var rules = [{
    path: "/tjxd/teachers",
  }, {
    path: "/tjxd/teacherContent/:id",
  }];

  return function (route) {
    return utilRouter.isMatch(route, rules)
  }
}
function isBrandsActive(id) {
  var rules = [{
    path: "/tjxd/brands/:menuId",
    params: {
      menuId: id
    }
  }];
  return function (route) {
    return utilRouter.isMatch(route, rules)
  }
}
// function isElaborateActive(id) {
//   var rules = [{
//     path: "/tjxd/elaborate/:declareType",
//     params: {
//       declareType: id
//     }
//   }];
//   return function (route) {
//     return utilRouter.isMatch(route, rules)
//   }
// }
// function isSchoolLevelActive(id) {
//   var rules = [{
//     path: "/tjxd/schoolLevel/:declareType",
//     params: {
//       declareType: id
//     }
//   }];
//   return function (route) {
//     return utilRouter.isMatch(route, rules)
//   }
// }

export default config;
